<template>
  <section class="bg-hero-image h-section mt-20">
    <div class="relative max-w-6xl mx-auto px-4 h-full flex justify-center items-center sm:px-6">
      <!-- Hero content -->
      <h1 class="h1 text-4xl text-white" data-aos="fade-up">からだトータルサポート</h1>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroKaradaSupport",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style scoped>
.bg-hero-image {
  background-image: url("./../images/services-background-01.jpg");
  background-size: cover;
  background-position: center;
}
.pt-72 {
  padding-top: 18rem;
}
.button {
  width: 240px;
  cursor: pointer;
}
</style>
